import type {Values} from '@wix/devzai-utils-common';

/**
 * Color mode of the social-link button chrome — controls which page color the
 * button plate (and/or its icon) inherits from. `TextColor` is the default.
 *
 * - `TextColor` (default) — for styled skins, the button plate uses the page
 *   **scope text color** and the inner icon uses the contrasting (scope
 *   background) color. For `Plain`, the bare icon's `color` is set to the
 *   page text color (only affects monochrome `Stroke` icons that draw with
 *   `currentColor`; brand-colored `Default` icons have hard-coded fills and
 *   are unaffected).
 * - `MainColor` — for styled skins, the plate uses the page main color
 *   (palette-derived). For `Plain`, the bare icon's `color` is the main
 *   color (again, affects only `currentColor`-driven Stroke icons).
 *
 * Skipped at render time when `socialLinksButtonStyle` is `Gradient` —
 * gradient stops are intrinsically palette-driven and the renderer keeps
 * them main-color-based regardless of the colorMode. The settings panel
 * hides the Color Mode dropdown only for `Gradient`.
 */
export const BymoPageSocialLinksColorMode = {
    MainColor: 'MainColor',
    TextColor: 'TextColor',
} as const;

export type BymoPageSocialLinksColorMode = Values<typeof BymoPageSocialLinksColorMode>;
